import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetUserDashboardTotalReward(params) {
  return await postRequest("analytics/engagement/rewards/total", params);
}
export async function serviceGetUserDashboardPet(params) {
  return await postRequest("analytics/pet/adoption", params);
}
export async function serviceGetUserDashboardReward(params) {
  return await postRequest("analytics/engagement/rewards/total", params);
}
export async function serviceGetUserDashboardTrend(params) {
  return await postRequest("analytics/engagement/rewards/trend", params);
}
export async function serviceGetUserDashboardEarned(params) {
  return await postRequest("analytics/engagement/rewards/earned", params);
}
export async function serviceGetUserDashboardRedeemed(params) {
  return await postRequest("analytics/engagement/rewards/redeemed", params);
}
export async function serviceGetUserDashboardEarnedTable(params) {
  return await postRequest("analytics/engagement/rewards/top/earners", params);
}
export async function serviceGetUserDashboardRedeemedTable(params) {
  return await postRequest("analytics/engagement/rewards/top/redeemers", params);
}
export async function serviceGetUserDashboardEngagementTable(params) {
  return await postRequest("analytics/engagement/module", params);
}
export async function serviceGetUserDashboardRadarChart(params) {
  return await postRequest("analytics/engagement/count", params);
}
export async function serviceProgramEngagementTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/program/engagement/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceProgramRedemptionTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/program/redemption/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
